var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-5" },
    [
      _c(
        "el-tabs",
        {
          staticClass: "mb-0 bg-white",
          attrs: { type: "card" },
          on: { "tab-click": _vm.typeClick },
          model: {
            value: _vm.listQuery.review_status,
            callback: function ($$v) {
              _vm.$set(_vm.listQuery, "review_status", $$v)
            },
            expression: "listQuery.review_status",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "全部", name: "-1" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "未审核", name: "1" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "已审核", name: "2" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "已驳回", name: "3" } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bg-white" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "list_table",
              attrs: {
                id: "list_table",
                data: _vm.list,
                "max-height": _vm.tableMaxH,
                "element-loading-text": "Loading",
                stripe: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "ID", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("div", [_vm._v(_vm._s(scope.row.id))])]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "图片", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _c("img", {
                            attrs: {
                              src: scope.row.img_url,
                              width: "140",
                              alt: "",
                            },
                          }),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "名称", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.ad_name) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "时间", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            _vm._v(
                              _vm._s(
                                _vm.parseTime(
                                  scope.row.start_date,
                                  "{y}-{m}-{d} {h}:{i}"
                                )
                              ) + "\n            "
                            ),
                            _c("el-link", { attrs: { type: "primary" } }, [
                              _vm._v("起"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _vm._v(
                              _vm._s(
                                _vm.parseTime(
                                  scope.row.end_date,
                                  "{y}-{m}-{d} {h}:{i}"
                                )
                              ) + "\n            "
                            ),
                            _c("el-link", { attrs: { type: "danger" } }, [
                              _vm._v("止"),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "定向地址" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary", href: scope.row.ad_link },
                          },
                          [_vm._v(_vm._s(scope.row.ad_link))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.statusObj[scope.row.review_status])
                          ),
                        ]),
                        _vm._v(" "),
                        scope.row.refuse_reason
                          ? _c("div", [
                              _vm._v(
                                "失败原因：" + _vm._s(scope.row.refuse_reason)
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "代理商", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("div", [_vm._v(_vm._s(scope.row.name))])]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.review_status == 1
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  round: "",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.auditOk(scope.row)
                                  },
                                },
                              },
                              [_vm._v("通过")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.review_status == 1
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  size: "mini",
                                  round: "",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.auditNo(scope.row)
                                  },
                                },
                              },
                              [_vm._v("驳回")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex justify-center" },
            [
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listQuery.page_num > 0,
                    expression: "listQuery.page_num > 0",
                  },
                ],
                attrs: {
                  page: _vm.listQuery.start,
                  "page-count": _vm.listQuery.page_num,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.listQuery, "start", $event)
                  },
                  pagination: _vm.getList,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }